// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2XKzF","savePackageButton":"ClientWallet_savePackageButton__2HVvp"};